import { ReferenzBahnstruktur } from './ReferenzBahnstruktur';
import { ReferenzBildung } from './ReferenzBildung';
import { ReferenzFinanz } from './ReferenzFinanz';
import { ReferenzForschung } from './ReferenzForschung';
import { ReferenzIndustrie } from './ReferenzIndustrie';
import { ReferenzKultur } from './ReferenzKultur';
import { ReferenzSozialbereich } from './ReferenzSozialbereich';
import { ReferenzUmwelt } from './ReferenzUmwelt';
import { ReferenzSonstiges } from './ReferenzSonstiges';

export const ReferenzenController = ({ referenceItem }) => {
  const getIllustration = () => {
    switch (referenceItem.title) {
      case 'Bahnstruktur':
        return <ReferenzBahnstruktur />;
      case 'Railway infrastructure':
        return <ReferenzBahnstruktur />;
      case 'Bildung':
        return <ReferenzBildung />;
      case 'Education':
        return <ReferenzBildung />;
      case 'Finanz':
        return <ReferenzFinanz />;
      case 'Finance':
        return <ReferenzFinanz />;
      case 'Forschung':
        return <ReferenzForschung />;
      case 'Research':
        return <ReferenzForschung />;
      case 'Industrie':
        return <ReferenzIndustrie />;
      case 'Industry':
        return <ReferenzIndustrie />;
      case 'Kultur':
        return <ReferenzKultur />;
      case 'Culture':
        return <ReferenzKultur />;
      case 'Sozialbereich':
        return <ReferenzSozialbereich />;
      case 'Social sector':
        return <ReferenzSozialbereich />;
      case 'Umwelt':
        return <ReferenzUmwelt />;
      case 'Environment':
        return <ReferenzUmwelt />;
      case 'Sonstiges':
        return <ReferenzSonstiges />;
      case 'Other':
        return <ReferenzSonstiges />;
      default:
        return '';
    }
  };

  return <>{getIllustration()}</>;
};
